import { render, staticRenderFns } from "./DynamicCheckbox.vue?vue&type=template&id=78b5ff20&scoped=true&"
import script from "./DynamicCheckbox.vue?vue&type=script&lang=js&"
export * from "./DynamicCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5ff20",
  null
  
)

export default component.exports